"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.List = void 0;
var _List = require("./List.styles");
var _ListItem = require("./partials/ListItem");
var _types = require("../../utilities/types");
var _AudienceListItem = require("../../Services/AudiencePicker/views/partials/AudienceSelectList/partials/AudienceList/partials/AudienceListItem");
var _jsxRuntime = require("react/jsx-runtime");
var List = function List(props) {
  var _props$role = props.role,
    role = _props$role === void 0 ? 'group' : _props$role,
    children = props.children,
    id = props.id,
    isMultiSelect = props.isMultiSelect;
  var childrenToCheck = Array.isArray(children) ? children : [children];
  (0, _types.validateChildren)(childrenToCheck, [_ListItem.ListItem, 'li', _AudienceListItem.AudienceListItem], 'List: Children must be of type li or ListItem');
  var styles = (0, _List.useStyles)(props);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("ul", {
    className: styles['cc-List'],
    role: role,
    id: id,
    "aria-multiselectable": isMultiSelect,
    "data-testid": id ? "ccList-".concat(id) : 'ccList',
    children: children
  });
};
exports.List = List;
List.Item = _ListItem.ListItem;